$(function(){
    // Fade-Overflow
    // expand/collapse truncated content modules
    $('.fade-overflow__trigger').each(function(index){
        $(this).on("click", function(e){
            e.preventDefault();
            $(this).closest('.fade-overflow').toggleClass('fade-overflow--expanded');
        });
    });
});
